export default __webpack_public_path__ + "static/media/hd-skills-embed.png?3b4b5011";